import React from 'react'
import injectStyles from 'react-jss'
import classNames from 'classnames'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import TableCell from '@material-ui/core/TableCell'
import TableSortLabel from '@material-ui/core/TableSortLabel'
import { Sort, ArrowDownward } from '@material-ui/icons'
import { switchOrderBy } from '../../../../Containers/City/Page/MasterSchedule/utils'
import { styles } from './styles'

const EnhancedTableHead = props => {
  const {
    classes,
    order,
    orderBy,
    onRequestSort,
    headCells,
    collapsableTable,
    headerPrefixComponent,
  } = props
  const createSortHandler = property => event => {
    onRequestSort(event, property)
  }
  const currentColumn = (orderBy, header) => {
    return orderBy
      ? Boolean(orderBy.search(switchOrderBy(header).toUpperCase()) + 1)
      : false
  }
  return (
    <TableHead className={classes.header}>
      <TableRow>
        {headerPrefixComponent && headerPrefixComponent()}
        {headCells.map(headCell => {
          const isThisColumn = currentColumn(orderBy, headCell.id)
          return (
            <TableCell
              key={headCell.id}
              align={collapsableTable ? 'left' : 'center'}
              padding={headCell.disablePadding ? 'none' : 'default'}
              sortDirection={isThisColumn ? order.toLowerCase() : false}
              className={classNames({
                [classes.disableBorderBottom]: collapsableTable,
                [classes.nonSortableHeader]: !headCell.sortable,
                [classes.delayColumn]: headCell.id === 'commDelay',
              })}
            >
              {headCell.sortable ? (
                <TableSortLabel
                  hideSortIcon={!headCell.sortable}
                  active={headCell.sortable}
                  IconComponent={
                    headCell.alwaysShowSortIcon && !isThisColumn
                      ? Sort
                      : ArrowDownward
                  }
                  direction={isThisColumn ? order.toLowerCase() : 'desc'}
                  onClick={createSortHandler(headCell.id)}
                >
                  {headCell.label}
                  <span className={classes.visuallyHidden}>
                    {order === 'DESC'
                      ? 'sorted descending'
                      : 'sorted ascending'}
                  </span>
                </TableSortLabel>
              ) : (
                headCell.label
              )}
            </TableCell>
          )
        })}
      </TableRow>
    </TableHead>
  )
}

export default injectStyles(styles)(EnhancedTableHead)
